import { Participant } from "@twilio/conversations"
import { TripCollaborator } from "@cruisen/react-shared"
import { _rootStore } from "../../../../models/helpers/useStores"
import { TypingUser } from "../../../atoms/TypingIndicator"

export const onTypingStarted = (participant: Participant, conversationSid: string) => {
  const currentCollaborator: TripCollaborator = _rootStore.activeTrip.collaborators.find(
    (collaborator: TripCollaborator) => collaborator.userId === _rootStore.loggedInUser.id,
  )
  if (
    participant.conversation.sid !== conversationSid ||
    participant.sid === currentCollaborator?.twilioParticipantSid
  ) {
    return
  }

  const attributes = participant.attributes as TypingUser

  const collaboratorUserData =
    _rootStore.activeTrip.collaborators.find(
      (collaborator) => collaborator.userId === attributes.userId,
    ) || attributes

  return collaboratorUserData
}

export const onTypingEnded = (participant: Participant, conversationSid: string) => {
  const currentCollaborator: TripCollaborator = _rootStore.activeTrip.collaborators.find(
    (collaborator: TripCollaborator) => collaborator.userId === _rootStore.loggedInUser.id,
  )
  if (
    participant.conversation.sid !== conversationSid ||
    participant.sid === currentCollaborator?.twilioParticipantSid
  ) {
    return
  }

  const attributes = participant.attributes as TypingUser

  const collaboratorUserData =
    _rootStore.activeTrip.collaborators.find(
      (collaborator) => collaborator.userId === attributes.userId,
    ) || attributes

  return collaboratorUserData
}
